var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryBeautyLover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "16px",
    viewBox: "0 0 10 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/choose category Copy 5@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-V3-Account---uploaded",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.1-Influencer-view_Instagram-Copy-2-(2)",
    transform: "translate(-754.000000, -770.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(585.000000, 683.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(165.000000, 87.000000)",
    id: "makeup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C64B4B",
    points: "1.73913043 3.47826087 7.30434783 1.73913043 7.30434783 11.1304348 1.73913043 11.1304348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52104348,4.54226087 C6.95478261,3.60695652 7.66991304,1.97321739 7.11791304,0.893565217 C6.56591304,-0.186434783 4.95617391,-0.303652174 3.52243478,0.631652174 C2.08869565,1.56695652 1.37356522,3.20069565 1.92556522,4.28034783 C2.47756522,5.36 4.08730435,5.47756522 5.52104348,4.54226087 Z",
    id: "Path",
    fill: "#E86C60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34782609,16 L0.695652174,16 C0.311304348,16 0,15.6886957 0,15.3043478 L0,10.4347826 C0,10.0504348 0.311304348,9.73913043 0.695652174,9.73913043 L8.34782609,9.73913043 C8.73217391,9.73913043 9.04347826,10.0504348 9.04347826,10.4347826 L9.04347826,15.3043478 C9.04347826,15.6886957 8.73217391,16 8.34782609,16 Z",
    id: "Path",
    fill: "#EFD358"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryBeautyLover);
export default __webpack_public_path__ + "static/media/category_beauty_lover.056865e69d8cf8c000424f7c17850f8d.svg";
export { ForwardRef as ReactComponent };